// extracted by mini-css-extract-plugin
export default {"textContainer":"text-input_textContainer__KxhAo","input":"text-input_input__3MAgI"};